<template>
  <div class="developer">
    <div class="part-1">
      <div class="main">
        <div class="left">
          <p class="tit">SDChain</p>
          <p class="desc">{{ $t('service.slider1.description') }}</p>
        </div>
        <div class="right">
          <img src="../assets/images/service/service-pic.png" alt />
        </div>
      </div>
    </div>
    <div class="part-11">
      <div class="main">
        <p class="title">{{ $t('service.part1.head') }}</p>
        <div class="desc">{{ $t('service.part1.desc') }}</div>
        <div class="items">
          <div class="item">
            <img src="../assets/images/service/service-part11-1.png" alt />
            <p class="p-1">{{ $t('service.part1.title1') }}</p>
            <p class="p-2">{{ $t('service.part1.desc1') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/service/service-part11-2.png" alt />
            <p class="p-1">{{ $t('service.part1.title2') }}</p>
            <p class="p-2">{{ $t('service.part1.desc2') }}</p>
          </div>
          <div class="item">
            <img src="../assets/images/service/service-part11-3.png" alt />
            <p class="p-1">{{ $t('service.part1.title3') }}</p>
            <p class="p-2">{{ $t('service.part1.desc3') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part-2">
      <div class="main">
        <p class="title">{{ $t('service.part2.head') }}</p>
        <div class="desc">{{ $t('service.part2.desc') }}</div>
        <div class="content">
          <div class="cont-item">
            <img src="../assets/images/service-part2-1.png" alt />
            <p class="tit">{{ $t('service.part2.title1') }}</p>
            <p class="desc">{{ $t('service.part2.description1') }}</p>
          </div>
          <div class="cont-item">
            <img src="../assets/images/service-part2-2.png" alt />
            <p class="tit">{{ $t('service.part2.title2') }}</p>
            <p class="desc">{{$t('service.part2.description2') }}</p>
          </div>
          <div class="cont-item">
            <img src="../assets/images/service-part2-3.png" alt />
            <p class="tit">{{ $t('service.part2.title3') }}</p>
            <p class="desc">{{ $t('service.part2.description3') }}</p>
          </div>
          <div class="cont-item">
            <img src="../assets/images/service-part2-4.png" alt />
            <p class="tit">{{ $t('service.part2.title4') }}</p>
            <p class="desc">{{ $t('service.part2.description4') }}</p>
          </div>
          <div class="cont-item">
            <img src="../assets/images/service-part2-5.png" alt />
            <p class="tit">{{ $t('service.part2.title5') }}</p>
            <p class="desc">{{ $t('service.part2.description5') }}</p>
          </div>
          <div class="cont-item">
            <img src="../assets/images/service-part2-6.png" alt />
            <p class="tit">{{ $t('service.part2.title6') }}</p>
            <p class="desc">{{ $t('service.part2.description6') }}</p>
          </div>
        </div>

        <!-- <div class="btn">
          <a href>{{ $t('service.part2.btn1') }}</a>
        </div>-->
      </div>
    </div>
    <div class="part-3">
      <div class="main">
        <p class="tit">{{ $t('service.part3.head') }}</p>
        <div class="desc">{{ $t('service.part3.desc') }}</div>
        <div class="content">
          <div class="left">
            <div class="conta">
              <p class="p-1">
                <span class="key">{{ $t('service.part3.title1') }} :</span>
                <span class="value">{{ runStartTime }}</span>
              </p>
              <p class="p-2">
                <span class="key">{{ $t('service.part3.title2') }}</span>
                <span class="value">{{ runDays }} </span>
                <span class="day">{{ $t('service.part3.day') }}</span>
              </p>
              <p  v-show="textcn"  class="p-3">
                <span class="key">{{ $t('service.part3.title3') }}</span>
                <span class="value">{{ nodeNumber }}</span>
              </p>
              <p  v-show="texten" class="p-3">
                <span class="key">{{ $t('service.part3.title3') }}</span>
                <span class="value-3">{{ nodeNumber }}</span>
              </p>
              <p v-show="textcn" class="p-4">
                <span class="key">{{ $t('service.part3.title4') }}</span>
                <span class="value">{{ height }}</span>
              </p>
              <p v-show="texten" class="p-4">
                <span class="key">{{ $t('service.part3.title4') }}</span>
                <span class="value-4">{{ height }}</span>
              </p>
              <p v-show="textcn" class="p-5">
                <span class="key">{{ $t('service.part3.title5') }}</span>
                <span class="value">{{ tradeAmount }}</span>
              </p>
              <p v-show="texten" class="p-5">
                <span class="key">{{ $t('service.part3.title5') }}</span>
                <span class="value-5">{{ tradeAmount }}</span>
              </p>
            </div>
            <div class="btn">
              <a
                href="https://holographic.sdchain.io/"
                target="_blank"
              >{{ $t('service.part3.btn1') }}</a>
            </div>
          </div>
          <div class="right">
            <img v-show="imgcn" src="../assets/images/service-part3-cn.png" alt />
             <img v-show="imgen" src="../assets/images/service-part3-en.png" alt />
              <img v-show="imgft" src="../assets/images/service-part3-ft.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import api from "../common/api";
import { setInterval, clearInterval } from "timers";

export default {
  name: "service",

  data() {
    return {
      runStartTime: "",
      runDays: "",
      nodeNumber: "",
      height: "",
      tradeAmount: "",
      interval: "",
      imgcn:false,
      imgen:false,
      imgft:false,
      textcn:false,
      texten:false,
    };
  },

  created() {
    this.getNodeInfo();
    this.setIntervalEvent();
    this.getLang();
  },

  mounted() {
    const swiper = new Swiper(".swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 15,
      // 如果需要前进后退按钮
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      slidesPerView: "auto",
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
  },

  beforeDestroy() {
    this.clearIntervalEvent();
  },

  methods: {
    setIntervalEvent() {
      this.interval = setInterval(() => this.getNodeInfo(), 10 * 1000);
    },
    
    getLang(){

       if(localStorage.Lang == "cn"){
         this.imgcn = true;
         this.textcn = true;
       }else  if(localStorage.Lang == "tw"){
         this.imgft = true;
         this.textcn = true;
       }else{
         this.imgen = true;
         this.texten = true;
       }
    },

    clearIntervalEvent() {
      clearInterval(this.interval);
    },

    getNodeInfo() {
      this.$axios
        .get(`${api.getNodeInfo}`)
        .then(res => {
          this.runStartTime = res.data.runTime;
          this.runDays = res.data.runCount;
          this.nodeNumber = res.data.nodesNumber;
          this.height = res.data.ledger;
          this.tradeAmount = res.data.txCount;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../assets/css/var.less");
.developer {
  .part-1 {
    overflow: hidden;
    width: 100%;
    height: 600px;
    background: linear-gradient(
      0deg,
      rgba(13, 119, 255, 1) 0%,
      rgba(82, 54, 250, 1) 100%
    );
    .clearfix();
    .left {
      float: left;
      width: 50%;
      .tit {
        font-size: 66px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        margin-top: 250px;
        padding-left: 80px;
      }
      .desc {
        padding-left: 80px;
        font-size: 22px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .right {
      float: left;
      width: 50%;
      img {
        width: 480px;
        height: 346px;
        margin-top: 150px;
        margin-left: 10px;
      }
    }
  }
  .part-11 {
    width: 100%;
    height: 742px;
    overflow: hidden;
    background-color: #fff;
    .main {
      padding: 0;
    }
    .title {
      text-align: center;
      margin-top: 90px;
      font-size: 30px;

      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .desc {
      margin-top: 13px;
      text-align: center;
      font-size: 20px;

      font-weight: 400;
      color: rgba(85, 85, 85, 1);
    }
    .items {
      width: 100%;
      height: 443px;
      display: flex;
      justify-content: space-between;
      margin-top: 55px;
      .item {
        width: 354px;
        height: 443px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        &:hover {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
        img {
          height: 115px;
          width: 115px;
          display: block;
          margin: 0 auto;
          margin-top: 89px;
        }
        .p-1 {
          margin-top: 65px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }
        .p-2 {
          margin-top: 15px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
         // text-align: justify;
          text-align: lefty;
          padding: 0 40px;
        }
      }
    }
  }
  .part-2 {
    height: 1100px;
    background-color: rgba(243, 246, 251, 1);
    overflow: hidden;
    .main {
      padding: 0;
    }
    .fenge {
      .fgx();
    }
    .title {
      text-align: center;
      margin-top: 90px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .desc {
      margin-top: 13px;
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      text-align: center;
    }
    .content {
      background-color: rgba(243, 246, 251, 1);
      margin-top: 55px;
      .clearfix();
      .cont-item {
        float: left;
        text-align: center;
        background: #fff;
        width: 350px;
        height: 350px;
        padding: 44px 30px 50px 30px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        &:hover {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        }
        &:nth-child(1) {
          margin: 0 45px 40px 0;
        }
        &:nth-child(2) {
          margin: 0 45px 40px 0;
        }
        &:nth-child(3) {
          margin-bottom: 40px;
        }
        &:nth-child(4) {
          margin-right: 45px;
        }
        &:nth-child(5) {
          margin-right: 45px;
        }
        .tit {
          text-align: center;
          font-size: 24px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          padding: 0 20px;
          margin-top: 20px;
        }
        .desc {
          padding: 0 20px;
          margin-top: 15px;
         // text-align: justify;
          text-align: left;
          font-size: 16px;
          font-weight: 400;
          color: rgba(85, 85, 85, 1);
        }
        img {
          width: 60px;
          height: 70px;
          margin: 0 auto;
        }
      }
    }

    .btn {
      text-align: center;
      margin-top: 80px;
      a {
        padding: 10px 25px;
        background-color: #558ff7;
        color: #fff;
        border-radius: 4px;
        font-size: 16px;
      }
    }
  }
  .part-3 {
    height: 791px;
    background-color: #ffffff;
    .main {
      padding: 0;
      overflow: hidden;
    }
    .fenge {
      .fgx();
    }
    .tit {
      text-align: center;
      margin-top: 90px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .desc {
      margin-top: 13px;
      font-size: 20px;
      font-weight: 400;
      color: rgba(85, 85, 85, 1);
      text-align: center;
    }
    .content {
      .left {
        float: left;
        width: 320px;
        .conta {
          width: 300px;
          height: 100%;
          text-align: left;
          // font-weight: 550;
          .p-1 {
           margin: 22px 22px 0 0;
            border-bottom: 1px solid #5189f6;
            font-weight: 400;
            font-size: 24px;
            span {
              padding: 8px 0;
              display: inline-block;
            }
            .key {
              color: rgba(51, 51, 51, 1);
             
            }
            .value {
              color: rgba(85, 143, 247, 1);
            }
          }
          .p-2 {
            font-size: 20px;
            font-weight: 400;
            padding-top: 28px;
            .key {
              font-weight: 400;
              color: rgba(67, 67, 67, 1);
               margin-right: 16px;
            }
            .value {
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
            .day{
              margin-left: 5px;
            }
          }
          .p-3 {
            font-size: 20px;
            font-weight: 400;
            padding-top: 24px;
            .key {
              font-weight: 400;
              color: rgba(67, 67, 67, 1);
               margin-right: 16px;
            }
            .value {
              margin-left: 20px;
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
            .value-3{
             margin-left: 28px;
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
          }
          .p-4 {
            font-size: 20px;
            font-weight: 400;
               padding-top: 24px;
            .key {
              font-weight: 400;
              color: rgba(67, 67, 67, 1);
               margin-right: 16px;
            }
            .value {
                margin-left: 20px;
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
            .value-4{
               margin-left: 50px;
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
          }
          .p-5 {
            font-size: 20px;
            font-weight: 400;
            padding-top: 24px;
            .key {
              font-weight: 400;
              color: rgba(67, 67, 67, 1);
               margin-right: 16px;
            }
            .value {
                margin-left: 20px;
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
            .value-5{
               margin-left: 26px;
              padding: 2px 16px;
              background: rgba(250, 251, 253, 1);
              border: 1px solid rgba(66, 127, 247, 1);
              border-radius: 5px;
              color:rgba(66,127,247,1);
            }
          }
        }
        .btn {
          width: 240px;
          height: 56px;
          background: rgba(85, 143, 247, 1);
          text-align: center;
          margin-top: 35px;
          cursor: pointer;
          a {
            line-height: 56px;
            font-size: 19px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      .right {
        width: 100%;
        padding-left: 320px;
        margin-top: 85px;
        img {
          width: 867px;
          height: 406px;
        }
      }
    }
  }
}
</style>
